import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { Language, LanguageLevel, CacheService, ILanguageBO, ITypeLevelLanguageBO } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  className = 'LanguageService'

  sections = [
    'administration'
  ]

  constructor(private http: HttpClient, private cacheService: CacheService, private router: Router) { }

  getAllLanguages(cache = true): Observable<ILanguageBO[]> {
    const isAdminSection = this.sections.some(section => this.router.url.includes(section));
    const cacheKey = 'allLanguages' + '_' + isAdminSection.toString();
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ILanguageBO[]>;
    } else {
      const observable = this.http.get<ILanguageBO[]>(environment.base_URL + "/languages").pipe(map((res) => {
        if (isAdminSection) {
          this.cacheService.updateCacheData(res, cacheKey);
          return res;
        } else {
          const filtrado = res.filter(it => it.mrkActive && it.idLanguagePk != 3 && it.idLanguagePk != 4 && it.idLanguagePk != 5);
          this.cacheService.updateCacheData(filtrado, cacheKey);
          return filtrado;
        }
      }));
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getAllLanguagesNoAutoID(): Observable<ILanguageBO[]> {
    return this.http.get<ILanguageBO[]>(environment.base_URL + "/languages").pipe(map<ILanguageBO[], ILanguageBO[]>(res => this.removeById(res)));
  }

  removeById(array: ILanguageBO[]) {
    // Solo se elimina el `id` autogenerado: idLanguagePk es la clave real y el back la necesita al guardar idiomas
    array.forEach((element: ILanguageBO & { id?: number }) => {
      delete element.id;
    });
    return array;
  }

  getAllLangByProps(propierties: keyof ILanguageBO | (keyof ILanguageBO)[]) {
    const keys = ([] as (keyof ILanguageBO)[]).concat(propierties);
    return this.getAllLanguages().pipe(map<ILanguageBO[], ILanguageBO[]>(res =>
      res.map(item => keys.reduce((acc, key) => ({ ...acc, [key]: item[key] }), {} as ILanguageBO))
    ));
  }

  newLanguage(language: ILanguageBO) {
    return this.http.post(environment.base_URL + "/languages", language).pipe(tap(() => this.deleteCache()))
  }

  updateLanguage(language: ILanguageBO, id: number) {
    return this.http.put(environment.base_URL + `/languages/${id}`, language).pipe(tap(() => this.deleteCache()))
  }

  deleteLanguage(id: number) {
    return this.http.delete(environment.base_URL + `/languages/${id}`).pipe(tap(() => this.deleteCache()))
  }

  /**
   *  Language Level
   */


  getAllLanguageLevels(cache = true, cacheKey = "allLanguageLevels"): Observable<ITypeLevelLanguageBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeLevelLanguageBO[]>;
    } else {
      const observable = this.http.get<ITypeLevelLanguageBO[]>(environment.base_URL + "/types-level-language").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
  newLanguageLevel(level: ITypeLevelLanguageBO) {
    return this.http.post(environment.base_URL + "/types-level-language", level).pipe(tap(() => this.deleteCache()))
  }

  updateLanguageLevel(level: ITypeLevelLanguageBO, id: number) {
    return this.http.put(environment.base_URL + `/types-level-language/${id}`, level).pipe(tap(() => this.deleteCache()))
  }

  /**
   * Delete Cache
   */

  deleteCache() {
    const memoryCache = ["allLanguages", "allLanguageLevels"];
    memoryCache.forEach(item => {
      this.cacheService.deleteCache(item);
    });
  }
}
